"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DETECTED_COUNTRY_DATA = exports.COUNTRY_LIST = exports.getDetectedCountryData = exports.getCountryDataByCode = exports.getCountries = void 0;
const countries_and_timezones_1 = __importDefault(require("countries-and-timezones"));
const i18n_iso_countries_1 = __importDefault(require("i18n-iso-countries"));
const en_json_1 = __importDefault(require("i18n-iso-countries/langs/en.json"));
const libphonenumber_js_1 = require("libphonenumber-js");
const DEFAULT_COUNTRY_CODE = 'US';
const enLocale = (en_json_1.default.default ?? en_json_1.default);
const COUNTRY_NAMES = i18n_iso_countries_1.default.getNames('en');
const COUNTRY_CODES = i18n_iso_countries_1.default.getAlpha2Codes();
try {
    i18n_iso_countries_1.default.registerLocale(enLocale);
}
catch (error) {
    console.error('Failed to register locale data for countries:', error);
}
const getCountries = () => {
    return (0, libphonenumber_js_1.getCountries)().map(buildCountryData).filter((country) => !!country.name);
};
exports.getCountries = getCountries;
const getCountryDataByCode = (code) => {
    const country = exports.COUNTRY_LIST.find((country) => country.code === code);
    if (!country)
        throw new Error(`Country with code "${code}" not found.`);
    return country;
};
exports.getCountryDataByCode = getCountryDataByCode;
const getDetectedCountryData = () => {
    const TIMEZONE_INFO = countries_and_timezones_1.default.getTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const DETECTED_COUNTRY_CODE = TIMEZONE_INFO?.countries[0] || DEFAULT_COUNTRY_CODE;
    const byCode = (countryCode) => exports.COUNTRY_LIST.find((country) => country.code === `${countryCode}_${(0, libphonenumber_js_1.getCountryCallingCode)(countryCode)}`);
    return byCode(DETECTED_COUNTRY_CODE) || byCode(DEFAULT_COUNTRY_CODE) || buildCountryData(DEFAULT_COUNTRY_CODE);
};
exports.getDetectedCountryData = getDetectedCountryData;
const buildCountryData = (countryCode) => {
    const callingCode = (0, libphonenumber_js_1.getCountryCallingCode)(countryCode);
    const localizedName = COUNTRY_NAMES[countryCode];
    const name = localizedName || COUNTRY_CODES[countryCode] || 'Unknown';
    const phoneCode = `+${callingCode}`;
    return {
        code: `${countryCode}_${callingCode}`,
        name,
        phoneCode,
        search: [name, countryCode, localizedName, phoneCode],
    };
};
exports.COUNTRY_LIST = (0, exports.getCountries)();
exports.DETECTED_COUNTRY_DATA = (0, exports.getDetectedCountryData)();
